import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import app from "./base.js";
import { Text, View, TouchableOpacity } from "react-native-web";
import { AuthContext } from "./Auth.js";
import firebase from "firebase";
import { Typography, Card } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import queryString from "query-string";
import "antd/dist/antd.css";

const Login = (props) => {
	const handleLogin = useCallback(
		async (event) => {
			event.preventDefault();
			const googleProvider = new firebase.auth.GoogleAuthProvider();
			try {
				await app.auth().signInWithRedirect(googleProvider);
				props.history.push("/");
			} catch (error) {
				alert(error);
			}
		},
		[props.history]
	);

	const handleAnonymousLogin = useCallback(
		async (event) => {
			event.preventDefault();
			try {
				await app.auth().signInAnonymously();
			} catch (error) {
				alert(error);
			}
		},
		[props.history]
	);

	const { currentUser } = useContext(AuthContext);
	if (currentUser) {
		const params = queryString.parse(props.location.search);
		if (params) {
			if (params.sid) {
				return (
					<Redirect
						to={{ pathname: "/survey", search: props.location.search }}
					/>
				);
			} else if (params.lid) {
				return (
					<Redirect to={{ pathname: "/live", search: props.location.search }} />
				);
			}
		}
		return <Redirect to={{ pathname: "/", search: props.location.search }} />;
	}

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
			}}
		>
			<View
				style={{
					alignItems: "center",
					borderColor: "#C5CCD6",
					borderWidth: 2,
					padding: 50,
					borderRadius: 10,
				}}
			>
				<img
					alt="hello"
					src={require("./images/icon.png")}
					style={{
						width: 80,
						height: 80,
						borderRadius: 5,
						alignSelf: "center",
					}}
				/>
				<Text
					style={{
						marginTop: 20,
						fontFamily: "NunitoSans",
						fontSize: 30,
						fontWeight: "bold",
					}}
				>
					Suggestify
				</Text>
				<Text
					style={{
						fontFamily: "NunitoSans",
						fontSize: 15,
						fontWeight: "500",
						color: "#888888",
					}}
				>
					Instant suggestions on-the-go
				</Text>
				<View style={{ marginTop: 20 }}>
					<TouchableOpacity
						style={{
							marginTop: 25,
							borderRadius: 20,
							padding: 10,
							backgroundColor: "#D03226",
							margin: 5,
						}}
						onPress={handleLogin}
					>
						<Text
							style={{
								fontFamily: "NunitoSans",
								fontSize: 15,
								fontWeight: "500",
								color: "white",
								textAlign: "center",
							}}
						>
							Continue with google
						</Text>
					</TouchableOpacity>
					<TouchableOpacity
						style={{
							marginTop: 5,
							borderRadius: 20,
							padding: 10,
							backgroundColor: "#368df8",
							margin: 5,
							width: 250,
						}}
						onPress={handleAnonymousLogin}
					>
						<Text
							style={{
								fontFamily: "NunitoSans",
								fontSize: 15,
								fontWeight: "500",
								color: "white",
								textAlign: "center",
							}}
						>
							Anonymous Login
						</Text>
					</TouchableOpacity>
				</View>
				<Text
					style={{
						marginTop: 10,
						fontFamily: "NunitoSans",
						fontSize: 12,
						fontWeight: "500",
						color: "#000",
						textAlign: "center",
					}}
				>
					Continue to vote and respond to surveys
				</Text>
			</View>
			{/* <div className="site-card-border-less-wrapper">
					<Card
						hoverable
						style={{
							width: '100%',
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<img
							alt="hello"
							src={require("./images/icon.png")}
							style={{
								width: 80,
								height: 80,
								borderRadius: 5,
								alignSelf: "center",
							}}
						/>
						<Text style={{ marginTop: 20 }}>
							Welcome to Suggestify
						</Text>
						<Button
							type="primary"
							icon={<GoogleOutlined />}
							onClick={handleLogin}
							style={{ borderRadius: 20, backgroundColor: "#196BFF" }}
							size='large'
						>
							Continue with google
						</Button>
					</Card>
				</div> */}
		</div>
	);
};

export default withRouter(Login);
